<template>
  <div id="app">
    <div id="header">
    <div id="logowrap"><router-link :to ="{name: 'Index'}"><img id="logo" :src="logo"></router-link></div>
      <ul class="menu">
        <li><router-link :to ="{name: 'Index'}">Home</router-link></li>
        <li><a v-on:click="submenu"><span v-lang.profile></span></a>
          <ul>
            <li><router-link :to ="{name:'about'}" ><span v-lang.about></span></router-link></li>
            <li><router-link :to ="{name:'portrait'}"><span v-lang.portrait></span></router-link></li>
          </ul>
        </li>
        <li><router-link :to ="{name: 'products'}" v-on:click="reset"><span v-lang.products></span></router-link></li>
        <li><a v-on:click="submenu"><span v-lang.news></span></a>
          <ul>
            <li><router-link :to ="{name: 'tradefairs'}"><span v-lang.events></span></router-link></li>
          </ul>
        </li>
        <li><a v-on:click="submenu"><span v-lang.service></span></a>
          <ul>
            <li><router-link :to ="{name: 'support'}"><span v-lang.hotline></span></router-link></li>
            <li><router-link :to ="{name: 'downloads'}"><span v-lang.downloads></span></router-link></li>
          </ul>
        </li>
        <li><a v-on:click="submenu"><span v-lang.contact></span></a>
          <ul>
            <li><router-link :to ="{name: 'prospekt'}"><span v-lang.prospekt></span></router-link></li>
            <li><router-link :to ="{name: 'newsletter'}"><span v-lang.newletter></span></router-link></li>
            <li><router-link :to ="{name: 'contact'}"><span v-lang.route></span></router-link></li>
            <li><router-link :to ="{name: 'contactpoint'}"><span v-lang.contactPoints></span></router-link></li>
          </ul>
        </li>
        <li><router-link :to ="{name: 'impressum'}" v-on:click="submenu"><span v-lang.imprint id="imp"></span></router-link>
          <ul>
            <li><router-link :to ="{name: 'agb'}"><span v-lang.tos></span></router-link></li>
          </ul>
        </li>
        <li class="right">
          <ul>
            <li><a v-on:click="lang($event,'de')"><flag iso="de"/></a></li>
            <li><a v-on:click="lang($event,'en')"><flag iso="us"/></a></li>
          </ul>
        </li>
      </ul>
      <div id="sub"></div>
  </div>
  <div class="content">
    <router-view/>
  </div>
  <footer>
      <i class="fa fa-copyright" aria-hidden="true"></i> schuett-biotec GmbH, Rudolf-Wissell-Str. 13, D-37079 G&ouml;ttingen <br /> Fon +49 (0) 551/5 041 0-0, Fax +49 (0) 551/5 04 10-99, <a href="mailto:info@schuett-biotec.de">info@schuett-biotec.de</a> <br><router-link :to ="{name: 'impressum'}" v-on:click="submenu"><span v-lang.imprint id="imp"></span></router-link>
  </footer>
  </div>

</template>

<script>
import logo from '@/assets/logo.jpg'
export default {
  name: 'app',
  data () {
    let lang = window.localStorage.getItem('vue-lang');
    return {
      language: lang ? lang : 'de',
      logo: logo,
      locales: [{id: 'en', name: 'English'}, {id: 'de', name: 'Deutsch'}]
    }
  },
  messages: {
      en: {
        profile: 'Profile',
        about: 'About us',
        portrait: 'Portrait',
        history: 'History',
        products: 'Products',
        news: 'News',
        recent: 'Recent',
        events: 'Events/Tradefairs',
        press: 'Press',
        service: 'Service',
        hotline: 'Supporthotline',
        quality: 'Quality',
        downloads: 'Downloads',
        faq: 'FAQ',
        contact: 'Contact',
        prospekt: 'Catalogue',
        newletter: 'Newsletter',
        route: 'Route',
        contactPoints: 'Contact Points',
        imprint: 'Imprint',
        tos: 'Terms of Service'
      },
      de: {
        profile: 'Profil',
        about: 'Über uns',
        portrait: 'Portrait',
        history: 'Geschichte',
        products: 'Produkte',
        news: 'News',
        recent: 'Neuigkeiten',
        events: 'Veranstaltungen/Messen',
        press: 'Presse',
        service: 'Service',
        hotline: 'Supporthotline',
        quality: 'Qualität',
        downloads: 'Downloads',
        faq: 'FAQ',
        contact: 'Kontakt',
        prospekt: 'Prospekt',
        newletter: 'Newsletter',
        route: 'Anfahrtsbeschreibung',
        contactPoints: 'Ansprechpartner',
        imprint: 'Impressum',
        tos: 'AGBs'
      }
  },
  watch: {
    '$route': function (e) {
      this.reset(e)
      if(this.$route.path === '/impressum')
        this.submenu({target: document.getElementById('imp')})
      this.indexing(e)
    }
  },
  methods: {
    lang: function(e,lang) {
      this.language = lang;
      this.$nextTick().then(() => {
        const curr = document.querySelector('li.curr');
        if(curr) {
          const sub = document.getElementById('sub')
          sub.innerHTML = curr.lastChild.outerHTML;
        }
      });
    },
    activate: function (e) {
      let el = e.target
      let active = document.querySelectorAll('.curr')
      if(active.length > 0)
        for (let element of active) {
          element.classList.remove('curr')
        }
      el.parentElement.parentElement.classList.add('curr')
    },
    submenu: function (e) {
      const sub = document.getElementById('sub')
      let ul = e.target.parentElement.nextElementSibling.outerHTML
      sub.innerHTML = ul
      this.activate(e)
    },
    reset: function (e) {
      const sub = document.getElementById('sub')
      if (sub.hasChildNodes()) {
        for (let child of sub.childNodes) {
          sub.removeChild(child)
        }
      }
    },
    indexing: function () {
      let route = this.$route.path
      const body = document.querySelector('body')
      const app = document.querySelector('#app')
      const footer = document.querySelector('footer')
      if (route !== '/') {
        if (body.classList.contains('black')) {
          body.classList.remove('black')
        }
        if (app.classList.contains('black')) {
          app.classList.remove('black')
        }
        body.classList.add('white')
        app.classList.add('white')
        footer.style.color = 'black';
      } else {
        if (body.classList.contains('white')) {
          body.classList.remove('white')
        }
        if (app.classList.contains('white')) {
          app.classList.remove('white')
        }
        body.classList.add('black')
        app.classList.add('black')
        footer.style.color = '#ccc';
      }
    }
  },
  beforeMount () {
    this.indexing()
  }
};
</script>

<style scoped>
#app {
  position: relative;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #ddd;
}

#logo,#logowrap,#header { background: black; }

#logo {
 padding: 10px 30px 10px 40px;
 max-width: 400px;
 text-align: left;
}

#header {
  vertical-align: middle;
  padding: 10px;
  margin-bottom: 50px;
}

.content {
  /*margin-top: 160px;*/
  height: 100%;
  padding-bottom: 5%;
}

.right {
  margin-top: -20px;
  float: right;
}

.right ul {
  padding-left: 5px;
}

.menu {
  margin-left: -10px;
}

ul li {
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  margin: auto;
  cursor: pointer;
}

.menu li:before {
  content: "•";
  color: red;
  padding-right: 5px;
}
li.right:before {
  content:"";
  color: black;
}

.curr:before {
  color: white;
}

li ul {
  display: none;
}

li ul li {
  display: hidden;
}

li.right ul {
  display: block;
}

li.right ul li {
  display: inline-block;
}
li.right ul li:before {
  content: "";
}

.fitlers {
  box-shadow: 0 1px 2px 5px red;
  filter: blur(1px) grayscale(75%);
}

a {
  cursor: pointer;
  text-decoration: none;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue